import { useMutation } from 'react-query';
import request from '../../../../helpers/request';

const mutationFn = ({ acceptanceId, deskIds, targetDate, intervals }) =>
  request.post(
    'Acceptance/view_calendar_add_intervals',
    { acceptanceId, deskIds, targetDate, intervals },
    'Не удалось добавить интервалы',
    'Error',
    undefined
  );

export const useAddCalendarIntervals = (options) =>
  useMutation(mutationFn, {
    ...options,
    onSuccess: (data, variables) => {
      if (data !== 'Error' && options?.onSuccess) {
        options.onSuccess(data, variables);
      }
    },
  });
